import React, { ReactElement, useCallback } from 'react';
import { RenderItem } from './RenderItem';
import { SupportedCardGalleryItemProps } from './SupportedCardGalleryItemProps';
import { ActionsCellAPI, GridState } from '../../state';
import { FiltersMap } from '@wix/bex-core';
import { AddItemProps } from '@wix/design-system';
import { DragAndDrop } from '../DragAndDrop';
import { ActionsCellProps } from '../ActionsCell';
import { GridItem } from './GridItem';

export interface UseRenderItemParams<T, F extends FiltersMap> {
  preset?: 'full' | 'title' | 'empty';

  renderItem?: (
    item: T,
    index: number,
  ) => Partial<SupportedCardGalleryItemProps>;

  state: GridState<T, F>;

  renderAddItem?: () => ReactElement<AddItemProps>;

  actionsCell?:
    | ActionsCellProps
    | ((item: T, index: number, api: ActionsCellAPI<T, F>) => ActionsCellProps);

  dragAndDrop?: DragAndDrop;
}

export function useRenderItem<T, F extends FiltersMap>(
  params: UseRenderItemParams<T, F>,
) {
  const {
    renderItem,
    state,
    renderAddItem,
    dragAndDrop,
    actionsCell,
    preset = 'title',
  } = params;

  return useCallback<RenderItem>(
    (index, { itemKey: _itemKey, index2d } = {}) => (
      <GridItem
        state={state}
        index={index}
        rowIndex={index2d?.rowIndex}
        columnIndex={index2d?.columnIndex}
        renderItem={renderItem}
        actionsCell={actionsCell}
        renderAddItem={renderAddItem}
        dragAndDrop={dragAndDrop}
        preset={preset}
      />
    ),
    [renderItem, actionsCell, renderAddItem, dragAndDrop, preset],
  );
}
